module.exports = "/_next/static/images/youtube-filled-icon-819cc8d85bd5d1c26dbfac04ec41d6d6.svg";